import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, Radio, ControlLabel, Grid, Row, Col, Tabs, Tab } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { Notes } from './tabs/Notes';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { ProviderSelectionsCommand } from '../../commands/ProviderSelectionsCommand';
import { LayoutCommand } from '../../../genericLayoutConfigurations/commands/LayoutCommand';
import { LayoutFolderCommand } from '../../../genericLayoutConfigurations/commands/LayoutFolderCommand';
import { LinesCommand } from '../../commands/LinesCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { SetOfDayTypesCommand } from '../../../genericLayoutConfigurations/commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';

import { ScheduleGeneratorBase } from '../common/ScheduleGeneratorBase';

export class GenerateSchedules extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    baseGenerator = new ScheduleGeneratorBase();

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            commands: {
                providerSelections: new ProviderSelectionsCommand(),
                layouts: new LayoutCommand("bussched"),
                layoutFolders: new LayoutFolderCommand("bussched"),
                lines: new LinesCommand(),
                stops: new PathStopsCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
            },
            providerSelections: {
                data: {
                    line: "",
                    layout: "",
                    stopsSched: true,
                    lineSched: false,
                    scheduleGenerationSelections: []
                },
                search: true
            },
            data: {
                layouts: [],
                folders: [],
                layoutsGrouped: [],
                lines: [],
                stops: [],
                setOfDayTypes: [],
                schedules: [],
            },
            form: {
                layout: undefined,
                line: undefined,
                stops: [],
                schedules: {},
                referenceDate: new Date().toISOString(),
                type: 1,
                colorType: 1,
            },
            validations: {
                schedulesComponents: [
                    "DayTimesheet",
                    "DayVerticalTimesheet",
                    "CompactDayTimesheet",
                    "VerticalDayTimesheet",
                    "HorizontalTabularDayTimesheet",
                    "VerticalTabularDayTimesheet",
                    "VerticalComposedDayTimesheet",
                    "PassingIntervals"
                ]
            },
            render: {
                tab: 1,
                setOfDayTypes: [],
                schedulesComponents: [],
                notesComponents: [],
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLayouts: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isLoadingStops: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);

        var edition = this.context.getOwnEdition();
        edition.addObserver(this);
        edition.updateSync(new Date());

        this.setState({ edition: edition }, function() {
            this.getProviderSelections();

            this.baseGenerator.getSetOfDayTypes(
                this.state,
                function(result) { this.onDataLoaded("setOfDayTypes", "isLoadingSetOfDayTypes", result); }.bind(this),
                function(err) { this.onDataError("setOfDayTypes", "isLoadingSetOfDayTypes", err); }.bind(this)
            );

            this.baseGenerator.getLayouts(
                this.state,
                function(result) {
                    this.onDataLoaded("layouts", "isLoadingLayouts", result, function() {
                        this.setState(function(prevState) {
                            var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(prevState.data.layouts, prevState.data.folders);
                            return { data: Object.assign({}, prevState.data, { layoutsGrouped: layoutsGrouped }) };
                        }.bind(this));
                    }.bind(this));
                }.bind(this),
                function(err) { this.onDataError("layouts", "isLoadingLayouts", err); }.bind(this)
            );

            this.baseGenerator.getFolders(
                this.state,
                function(folders) {
                    this.setState(function(prevState) {
                        var layoutsGrouped = this.baseGenerator.groupLayoutsByFolder(prevState.data.layouts, folders);
                        return { data: Object.assign({}, prevState.data, { folders: folders, layoutsGrouped: layoutsGrouped }) };
                    }.bind(this));
                }.bind(this),
                function() {}
            );
        }.bind(this));
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // EDITION
    // ----------------------

    startUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: true }) };
        });
    }

    endUpdate() {
        this.setState(function(prevState) {
            return { actions: Object.assign({}, prevState.actions, { isLoadingEdition: false }) };
        });
    }

    updateNetwork() {
        this.setState(
            function(prevState) {
                return {
                    form: Object.assign({}, prevState.form, { line: undefined }),
                    actions: Object.assign({}, prevState.actions, { isLoadingLines: true })
                };
            },
            function() {
                this.baseGenerator.getLines(
                    this.state,
                    function(result) {
                        this.onDataLoaded("lines", "isLoadingLines", result, function() {
                            this.onLinesReady();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    updatePlanning() {
        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingSchedules: true }) };
            },
            function() {
                this.baseGenerator.getSchedules(
                    this.state,
                    function(result) { this.onDataLoaded("schedules", "isLoadingSchedules", result); }.bind(this),
                    function(err) { this.onDataError("schedules", "isLoadingSchedules", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    // DATA LOADING
    // ----------------------

    onDataLoaded(dataType, loadingFlag, result, afterCallback) {
        this.setState(
            function(prevState) {
                var newData = Object.assign({}, prevState.data);
                newData[dataType] = result;
                var newActions = Object.assign({}, prevState.actions);
                newActions[loadingFlag] = false;
                return { data: newData, actions: newActions };
            },
            function() {
                if (typeof afterCallback === "function") {
                    afterCallback();
                } else {
                    this.setState(function(prevState) {
                        var layoutState = this.baseGenerator.computeLayoutSelected(prevState);
                        var merged = Object.assign({}, prevState, layoutState);
                        var selectionState = this.baseGenerator.computeSelectionExists(merged, false);
                        return selectionState
                            ? Object.assign({}, layoutState, selectionState)
                            : layoutState;
                    }.bind(this));
                }
            }.bind(this)
        );
    }

    onDataError(dataType, loadingFlag, message) {
        this.setState(function(prevState) {
            var newData = Object.assign({}, prevState.data);
            newData[dataType] = [];
            var newActions = Object.assign({}, prevState.actions);
            newActions[loadingFlag] = false;
            var msg = prevState.message.show
                ? prevState.message.message + "\n" + message
                : message;
            return {
                data: newData,
                actions: newActions,
                message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
            };
        });
    }

    // PROVIDER SELECTIONS
    // ----------------------

    getProviderSelections() {
        this.state.commands.providerSelections.get(
            function(result) { this.onProviderSelectionsLoaded(result); }.bind(this)
        );
    }

    onProviderSelectionsLoaded(result) {
        if (result == null) return;

        this.setState(
            function(prevState) {
                if (prevState.actions.isGenerating) return null;

                var newForm = Object.assign({}, prevState.form, {
                    layout: result.layout !== undefined ? result.layout : prevState.form.layout,
                    type: result.stopsSched ? 1 : 2,
                    referenceDate: (result.referenceDate && new Date(result.referenceDate).getFullYear() > 1) ? result.referenceDate : prevState.form.referenceDate
                });

                return {
                    providerSelections: Object.assign({}, prevState.providerSelections, { data: result }),
                    form: newForm,
                    render: Object.assign({}, prevState.render, { tab: result.stopsSched ? 1 : 2 })
                };
            },
            function() {
                this.state.edition.update(new Date(this.state.form.referenceDate));

                if (!this.state.form.layout) return;

                this.applyLayoutSelected();

                this.baseGenerator.getLines(
                    this.state,
                    function(res) {
                        this.onDataLoaded("lines", "isLoadingLines", res, function() {
                            this.onLinesReady();
                        }.bind(this));
                    }.bind(this),
                    function(err) { this.onDataError("lines", "isLoadingLines", err); }.bind(this)
                );

                this.baseGenerator.getSchedules(
                    this.state,
                    function(res) { this.onDataLoaded("schedules", "isLoadingSchedules", res); }.bind(this),
                    function(err) { this.onDataError("schedules", "isLoadingSchedules", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    onLinesReady() {
        this.setState(
            function(prevState) {
                var providerSelections = prevState.providerSelections;
                var preferredCode = (prevState.form && prevState.form.line && prevState.form.line.code) ? prevState.form.line.code : providerSelections.data.line;

                var line = prevState.data.lines.find(function(l) {
                    return l.code === preferredCode;
                });

                if (!line) return null;
                return { form: Object.assign({}, prevState.form, { line: line }) };
            },
            function() {
                this.applySelectionsToCurrent();
                this.loadStops();
            }.bind(this)
        );
    }

    loadStops() {
        if (!this.state.form.line) return;

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isLoadingStops: true }) };
            },
            function() {
                this.baseGenerator.getStops(
                    this.state,
                    function(result) { this.onDataLoaded("stops", "isLoadingStops", result); }.bind(this),
                    function(err) { this.onDataError("stops", "isLoadingStops", err); }.bind(this)
                );
            }.bind(this)
        );
    }

    updateProviderSelections() {
        var payload = this.baseGenerator.computeProviderSelectionsPayload(this.state);
        this.state.commands.providerSelections.update(
            payload,
            function(result) { this.onProviderSelectionsLoaded(result); }.bind(this)
        );
    }

    // SELECTIONS
    // ----------------------

    applySelectionsToCurrent() {
        var computed = this.baseGenerator.computeSelectionExists(this.state, false);
        if (!computed) return;
        this.setState(computed);
    }

    applyLayoutSelected() {
        var computed = this.baseGenerator.computeLayoutSelected(this.state);
        this.setState(computed);
    }

    // USER INTERACTIONS
    // ----------------------

    onChangeLineSelected() {
        if (!this.state.form.line) {
            this.setState(function(prevState) {
                return {
                    form: Object.assign({}, prevState.form, { stops: [] }),
                    data: Object.assign({}, prevState.data, { stops: [] })
                };
            });
            return;
        }
        this.loadStops();
    }

    onChangeLayoutSelected() {
        this.setState(
            function(prevState) {
                return this.baseGenerator.computeLayoutSelected(prevState);
            }.bind(this),
            function() {
                this.applySelectionsToCurrent();
            }.bind(this)
        );
    }

    onSelectValue(e, property, callback) {
        this.setState(
            function(prevState) {
                var newForm = Object.assign({}, prevState.form);
                newForm[property] = e === null ? undefined : e;
                return { form: newForm };
            },
            function() {
                if (typeof callback === "function") callback();
            }
        );
    }

    onChangeReferenceDateChange(date) {
        this.setState(
            function(prevState) {
                return { form: Object.assign({}, prevState.form, { referenceDate: date }) };
            },
            function() {
                this.state.edition.update(new Date(date));
            }.bind(this)
        );
    }

    onSortChange(column) {
        this.setState(function(prevState) {
            var sort = Object.assign({}, prevState.sort);
            if (sort.column === column) {
                sort.order = sort.order === "ascending" ? "descending" : "ascending";
            } else {
                sort.column = column;
                sort.order = "ascending";
            }
            return { sort: sort };
        });
    }

    onSelectAllStops() {
        this.setState(function(prevState) {
            var full = prevState.form.stops.length === prevState.data.stops.length;
            return {
                form: Object.assign({}, prevState.form, { stops: full ? [] : prevState.data.stops.slice() })
            };
        });
    }

    onStopRowClick(stop) {
        this.setState(function(prevState) {
            var stops = prevState.form.stops.slice();
            var index = stops.findIndex(function(s) { return s.code === stop.code; });
            if (index === -1) {
                stops.push(stop);
            } else {
                stops.splice(index, 1);
            }
            return { form: Object.assign({}, prevState.form, { stops: stops }) };
        });
    }

    onScheduleRowClick(schedule, componentId, setOfDayTypesId, index) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + index;

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var schedIndex = currentSchedules[objKey].indexOf(schedule.id);
            if (schedIndex === -1) {
                currentSchedules[objKey].push(schedule.id);
            } else {
                currentSchedules[objKey].splice(schedIndex, 1);

                if (currentSchedules[objKey].length === 0) {
                    delete currentSchedules[objKey];
                }
            }

            newForm.schedules = currentSchedules;
            return { form: newForm };
        });
    }

    onSelectAllSchedules(component, setOfDayTypesId) {
        this.setState(function(prevState) {
            var newForm = Object.assign({}, prevState.form);
            var objKey = newForm.line.code + "§" + component.componentId + "§" + newForm.type + "§" + setOfDayTypesId + "§" + component.index;

            var currentSchedules = Object.assign({}, newForm.schedules);
            if (!Array.isArray(currentSchedules[objKey])) {
                currentSchedules[objKey] = [];
            } else {
                currentSchedules[objKey] = currentSchedules[objKey].slice();
            }

            var remove = true;
            component.schedules.forEach(function(sched) {
                if (currentSchedules[objKey].indexOf(sched.id) === -1) {
                    remove = false;
                    currentSchedules[objKey].push(sched.id);
                }
            });

            if (remove) {
                component.schedules.forEach(function(sched) {
                    var idx = currentSchedules[objKey].indexOf(sched.id);
                    if (idx !== -1) {
                        currentSchedules[objKey].splice(idx, 1);
                    }
                });
            }

            newForm.schedules = currentSchedules;
            return {
                form: newForm,
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onChangeNotes(e, componentId) {
        var value = e.target.value;
        this.setState(function(prevState) {
            var newNotesComponents = prevState.render.notesComponents.map(function(c) {
                if (c.id === componentId) return Object.assign({}, c, { notes: value });
                return c;
            });
            return {
                render: Object.assign({}, prevState.render, { notesComponents: newNotesComponents }),
                providerSelections: Object.assign({}, prevState.providerSelections, { search: false })
            };
        });
    }

    onTabSelected(key) {
        this.setState(function(prevState) {
            return { render: Object.assign({}, prevState.render, { tab: key }) };
        });
    }

    onExitMessage() {
        this.setState({
            message: { show: false, title: undefined, message: undefined, style: undefined, icon: undefined }
        });
    }

    // GENERATE
    // ----------------------

    onGenerateClick() {
        var form = this.state.form;
        var render = this.state.render;
        var commands = this.state.commands;

        if (Object.keys(form.schedules).length === 0 || form.layout === undefined) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos um horário e um layout.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        var data = {
            lineId: form.line.id,
            Notes: render.notesComponents.map(function(component) {
                return { componentId: component.id, notes: component.notes };
            }),
            lineCode: form.line.code,
            componentSchedules: {},
            referenceDate: form.referenceDate,
            colorType: form.colorType,
        };

        for (var objKey in form.schedules) {
            var keyData = objKey.split("§");
            var componentId = keyData[1];
            var setId = keyData[3];

            if (componentId === undefined || setId === undefined) {
                continue;
            }

            this.baseGenerator.filterAllowedSchedules(this.state, componentId, objKey);

            if (data.componentSchedules[componentId] === undefined) {
                data.componentSchedules[componentId] = {};
            }
            data.componentSchedules[componentId][setId] = form.schedules[objKey];
        }

        var self = this;

        var onSuccess = function(a) {
            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: { show: true, message: msg, style: "success", title: "Sucesso", icon: "ok" }
                };
            });
        };

        var onError = function(a) {
            self.setState(function(prevState) {
                var msg = prevState.message.show ? prevState.message.message + "\n" + a : a;
                return {
                    actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                    message: { show: true, message: msg, style: "danger", title: "Erro", icon: "remove" }
                };
            });
        };

        this.setState(
            function(prevState) {
                return { actions: Object.assign({}, prevState.actions, { isGenerating: true }) };
            },
            function() {
                if (form.type === 1) {
                    if (form.stops.length === 0) {
                        self.setState(function(prevState) {
                            return {
                                actions: Object.assign({}, prevState.actions, { isGenerating: false }),
                                message: { show: true, title: "Aviso", message: "Antes de gerar é necessário selecionar pelo menos uma paragem.", style: "warning", icon: "alert" }
                            };
                        });
                        return;
                    }
                    data.Stops = form.stops;
                    self.updateProviderSelections();
                    commands.draw.generateBusSched(form.layout, data, onSuccess, onError);
                } else {
                    self.updateProviderSelections();
                    commands.draw.generateLineSched(form.layout, data, onSuccess, onError);
                }
            }
        );
    }

    // RENDERS
    // ----------------------

    renderForm() {
        var data = this.state.data;
        var form = this.state.form;
        var actions = this.state.actions;
        var self = this;

        if (actions.isLoadingLines) {
            return <LoadingSpinner />;
        }

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Linha</ControlLabel>
                        </Col>
                        <Col sm={10} md={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={function() { return "Sem Linhas Configurados"; }}
                                onChange={function(e) {
                                    self.onSelectValue(e, "line", function() {
                                        self.onChangeLineSelected();
                                    });
                                }}
                                options={data.lines.sort(function(a, b) { return a.code > b.code ? 1 : -1; })}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function(a) {
                                    if (form.line !== null && form.line !== undefined) {
                                        return form.line.code === a.code;
                                    }
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.code + " | " + label.goName; }}
                                value={form.line}
                            />
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={10} md={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={function() { return "Sem Layouts Configurados"; }}
                                onChange={function(e) {
                                    self.onSelectValue(e, "layout", function() {
                                        self.onChangeLayoutSelected();
                                    });
                                }}
                                options={data.layoutsGrouped.length > 0 ? data.layoutsGrouped : data.layouts.sort(function(a, b) { return a.name.localeCompare(b.name); })}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function(a) {
                                    if (form.layout !== null && form.layout !== undefined) {
                                        return form.layout.id === a.id;
                                    }
                                }}
                                getOptionValue={function(value) { return value; }}
                                getOptionLabel={function(label) { return label.name; }}
                                value={form.layout}
                            />
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={5} md={7}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={function(e) { self.onChangeReferenceDateChange(e); }} />
                        </Col>
                        <Col sm={5} md={4}>
                            <Radio key={1}
                                className="padding-top-7"
                                checked={form.type === 1}
                                onChange={function() { self.onSelectValue(1, "type"); }}
                                inline>
                                Horário de Paragem
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="padding-top-7 no-margin-left"
                                checked={form.type === 2}
                                onChange={function() {
                                    self.onSelectValue(2, "type", function() {
                                        self.setState(function(prevState) {
                                            var newRender = Object.assign({}, prevState.render);
                                            if (newRender.tab === 1) newRender.tab = 2;
                                            return { render: newRender };
                                        });
                                    });
                                }}
                                inline>
                                Horário de Linha
                            </Radio>
                        </Col>
                        <Col sm={5} md={4}>
                            <Radio key={1}
                                className="padding-top-7"
                                checked={form.colorType === 1}
                                onChange={function () { self.onSelectValue(1, "colorType"); }}
                                inline>
                                Cor Digital
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="padding-top-7 no-margin-left"
                                checked={form.colorType === 2}
                                onChange={function () {
                                    self.onSelectValue(2, "colorType", function () {
                                        self.setState(function (prevState) {
                                            var newRender = Object.assign({}, prevState.render);
                                            if (newRender.tab === 1) newRender.tab = 2;
                                            return { render: newRender };
                                        });
                                    });
                                }}
                                inline>
                                Cor Papel
                            </Radio>
                        </Col>
                    </Row>
                </FormGroup>
            </Grid>
        );
    }

    renderStopsTab() {
        var form = this.state.form;
        var actions = this.state.actions;

        if (form.type === 2) {
            return null;
        }

        if (actions.isLoadingStops) {
            return (
                <Tab eventKey={1} key="geral" title="Paragens">
                    <LoadingSpinner />
                </Tab>
            );
        }

        var self = this;
        var state = this.state;

        return (
            <Tab eventKey={1} key="geral" title="Paragens">
                {this.baseGenerator.renderStopsTab(
                    state,
                    function(column) { self.onSortChange(column); },
                    function() { self.onSelectAllStops(); },
                    function(stop) { self.onStopRowClick(stop); }
                )}
            </Tab>
        );
    }

    renderSchedulesTab() {
        var self = this;
        var state = this.state;

        return this.baseGenerator.renderSchedulesTab(
            state,
            function(component, setOfDayTypesId) { self.onSelectAllSchedules(component, setOfDayTypesId); },
            function(form, schedule, componentId, setOfDayTypesId, index) { self.onScheduleRowClick(schedule, componentId, setOfDayTypesId, index); }
        );
    }

    renderBody() {
        var actions = this.state.actions;
        var render = this.state.render;
        var self = this;

        if (actions.isLoadingStops) {
            return <LoadingSpinner />;
        }

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={function(a) { self.onTabSelected(a); }}>
                {this.renderStopsTab()}
                <Tab eventKey={2} key="sched" title="Horários">
                    {this.renderSchedulesTab()}
                </Tab>
                <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                    <Notes
                        components={render.notesComponents}
                        onChange={function(e, id) { self.onChangeNotes(e, id); }} />
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return <LoadingSpinner />;
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        var actions = this.state.actions;
        var message = this.state.message;
        var self = this;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={function() { self.updateProviderSelections(); }}>ATUALIZAR SELEÇÕES</Button>
                            <Button onClick={function() { self.onGenerateClick(); }}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLayouts || actions.isLoadingLines || actions.isLoadingSchedules || actions.isLoadingSetOfDayTypes)}
                {this.baseGenerator.renderGeneratingFeedback(actions.isGenerating)}
                {this.baseGenerator.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={function() { self.onExitMessage(); }} />
            </div>
        );
    }
}